import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomBreadcrumb } from "../custom-breadcrumb/custom-breadcrumb";
import { CustomTable } from "../custom-table/custom-table";
import { SERVICES } from "../../../core/services/services";
import { CustomLoader } from "../custom-loader/custom-loader";
import { Toast } from "primereact/toast";
import { HELPER } from "../../helper/helper";
import ErrorBoundary from "../error-boundary/error-boundary";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { UserTypes } from "../../constants";
import { FRONTOFFICE_API } from "../../../core/apis/frontoffice-apis";
import { Optional } from "../optional/optional";
import { MandateCancellationRequestDetails } from "./cancellation-request-details";

export function MandateCancellationRequests(props) {
  const toast = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState("");
  const [search, setSearch] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [range] = useState(5);
  const [emptyText, setEmptyText] = useState("No cancellation requests found");
  const [details, setDetails] = useState([]);
  const [debitMandates, setDebitMandates] = useState([]);
  const [pageNo, setPageNo] = useState(0);
  const [searchParams, setSearchParams] = useState(null);
  const [selectedMandate, setSelectedMandate] = useState(null);

  const tableHeaders = [
    { label: "Name", value: "name" },
    { label: "Account Number", value: "accountNumber" },
    {
      label: "Reference",
      value: "reference",
    },
    { label: "Payment Facilitator", value: "paymentFacilitatorName" },
    { label: "Merchant Name", value: "merchantName" },
    { label: "Status", value: "status" },
    { label: "Created On", value: "creationDate" },
    { label: "Expires On", value: "expiryDate" },
    { label: "Actions", value: "actions" },
  ];

  const getMandateDetails = useCallback((e) => {
    let mandateDetails = [];
    // HELPER.GET_DETAILS_ARRAY(e);
    // GET_MANDATE_DETAILS_ARRAY(e);
    setSelectedMandate(e);
    setDetails([]);
    setDetails(mandateDetails);
    setCurrentIndex(3);
  }, []);

  const openAction = useCallback(
    (e, action, isMobile) => {
      // eslint-disable-next-line default-case
      switch (action) {
        case "VIEW": {
          getMandateDetails(e, isMobile);
          break;
        }
      }
    },
    [getMandateDetails]
  );

  function goToPage(pageNo) {
    setPageNo(pageNo);
  }

  const getDebitMandates = useCallback(
    (isReload) => {
      setCurrentIndex(0);
      setDebitMandates([]);
      let params = {
        page: isReload ? 0 : pageNo,
        size: 10,
      };
      if (searchParams && !isReload) {
        setSearch(true);
        params = { ...params, ...searchParams };
      }
      params = HELPER.TO_URL_STRING(params);
      const url =
        props.userType === UserTypes.Frontoffice
          ? FRONTOFFICE_API.DEBIT_MANDATES
          : BACKOFFICE_API.DEBIT_MANDATES;
      SERVICES.MAKE_GET_REQUEST(url, params)
        .then((data) => {
          const result = data?.result?.content;
          if (!result.length) {
            setEmptyText("No cancellation requests found ...");
          } else {
            setTotalItems(data?.result.totalElements);
            setTotalPages(data?.result.totalPages);
            const arr = result.map((e) => ({
              ...e,
              actions: "CR",
              detailsFunction: openAction,
            }));
            setDebitMandates(arr);
          }
          setError(null);
          setCurrentIndex(1);
        })
        .catch((error) => {
          setError(HELPER.PROCESS_ERROR(error));
          setCurrentIndex(1);
        });
    },
    [pageNo, searchParams, openAction, props.userType]
  );

  useEffect(() => {
    getDebitMandates();
  }, [getDebitMandates]);

  function reload() {
    const isReload = true;
    setCurrentIndex(0);
    getDebitMandates(isReload);
    setSearchParams(null);
  }

  function goBack(isReload) {
    if (isReload === true) {
      getDebitMandates();
      return;
    }
    setCurrentIndex(1);
  }

  const renderMandates = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container">
            <CustomLoader loadingText="Loading cancellation requests..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            isReload={true}
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={range}
            emptyText={emptyText}
            search={search}
            reload={reload}
            error={error}
            items={debitMandates}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={goToPage}
          />
        );
      case 3:
        return (
          <div className="p-mt-2">
            <MandateCancellationRequestDetails
              goBack={goBack}
              details={details}
              mandate={selectedMandate}
              userType={props.userType}
              onReload={reload}
            />
          </div>
        );
    }
  };

  return (
    <ErrorBoundary>
      <div>
        <Toast ref={toast} />
        <div className="page-title p-text-left">
          Mandate Cancellation Requests
        </div>
        <div className="p-mt-2">
          <CustomBreadcrumb page="Manage Mandate Cancellation Requests" />
        </div>
        <div className="floating-buttons desktop-scree">
          <div className="p-grid">
            <div className="p-col-7"></div>
            <div className="p-col-5">
              <div className="p-grid">
                <div className="p-col-6"></div>
                <div className="p-col-6"></div>
              </div>
            </div>
          </div>
        </div>
        <Optional
          show={
            HELPER.HAS_AUTHORITY("fo_view_debit_mandates") ||
            HELPER.HAS_AUTHORITY("bo_view_debit_mandates")
          }
        >
          {renderMandates()}
        </Optional>
      </div>
    </ErrorBoundary>
  );
}
